// Used for product list tabs
export const SPOT_PURCHASE_ID = "spot";
export const FIXED_ID = "fixed";
export const CUSTOM_ID = "custom";
export const PLUS_ID = "plus";
